import React, { createContext, FunctionComponent, useState, useEffect } from "react";
import { fetchArticlePolymer, fetchSuperTestShock } from "@Services/article";

console.log("fetchArticlePolymer", fetchArticlePolymer);

export interface tableType {
  title: string;
  image: string;
  type: "word" | "image" | "wordAndImage";
}

export interface barType {
  value: Array<number>;
  key: string;
  unit: string;
}

export interface horizontalBarType {
  title: string;
  image: string;
  key: string[];
  type: "word" | "image" | "wordAndImage";
}

export interface tabType {
  title: string;
  image: string;
  values: Array<string> | string;
  type: "images" | "image";
  relationChartId: number;
  description?: string;
  selected?: number;
}

export interface ICharts {
  chartName: string;
  chartType: "table" | "bar" | "horizontalBar" | "tab";
  chartTopDescription: string;
  chartFooterDescription: string;
  chartData: Array<Array<tableType>> | Array<Array<barType>> | Array<horizontalBarType> | Array<Array<tabType>>;
}

export interface IBarkeCardData {
  title: string;
  thumb: string;
  link: string;
  environment: string;
  value: string;
  unit: string;
}

export interface IConsumptionCardData {
  title: string;
  thumb: string;
  link: string;
  environment: string;
  tirePressure: string;
  avgYearEnergyConsumption: string;
  bureauEnergyData: string;
  showImage: Array<{
    key: string;
    value: string;
  }>;
}

export interface ISpeedCardData {
  fullName: string;
  thumb: string;
  date: string;
  weather: string;
  temperature: string;
  speedwayName: string;
  speed: string;
  isCompare: number;
}

export interface IKindInfo {
  environment: string;
  myid: number;
  title: string;
  thumb: string;
}

export interface ChartsType {
  [key: string]: ICharts;
}

export interface KindDataType {
  "100to0Brake": IBarkeCardData[];
  energyConsumption: IConsumptionCardData[];
  speedways: ISpeedCardData[];
  kindInfo: IKindInfo[];
}

export interface ShockType {
  shock: Array<{
    modelName: string;
    list: Array<{
      data: number[];
      name: string;
      value: string;
    }>;
  }>;
  type: 1 | 2;
}

interface IData {
  charts: ChartsType;
  chartMapData: ChartsType;
  kindData: KindDataType;
  compareMyid: string | undefined;
  shockData: ShockType[];
  setCompare: React.Dispatch<React.SetStateAction<string | undefined>>;
}

// chartMapData
//   1 => '車系編成',
//   2 => '內外設計',
//   3 => '駕駛輔助系統差異表',
//   4 => '空間測量-table',
//   5 => '控監測量-tab',
//   6 => '舒適性測試',
//   7 => '30km/h震動數據',
//   8 => '車室隔音對照表',
//   9 => '座椅乘坐感',
//   10 => '性能測試',
//   11 => '加速成績',
//   12 => '100-0km/h煞停距離',
//   13 => '能耗測試表',

const initData = {
  charts: {
    "1": {
      chartName: "",
      chartType: "table",
      chartTopDescription: "",
      chartFooterDescription: "",
      chartData: [],
    },
  },
  compareMyid: "",
  kindData: {
    "100to0Brake": {},
    energyConsumption: {},
    speedways: {},
  },
};

export const Context = createContext<IData>(initData);

const Provider: FunctionComponent = ({ children }) => {
  const [charts, setCharts] = useState<ChartsType>({});
  const [chartMapData, setChartsMapData] = useState<ChartsType>({});
  const [kindData, setKindData] = useState<KindDataType>({});
  const [ids, setIds] = useState<number[]>([]);
  const [shockData, setShockData] = useState<ShockType[]>([]);
  const [compareMyid, setCompare] = useState<string | undefined>(undefined);

  const fetch = async () => {
    const res = await fetchArticlePolymer({
      objectId: window.article_id,
      type: 2,
      compareMyid,
    });

    console.log(res);

    if (res.status === 12000) {
      setCharts(res.data.charts);
      setKindData(res.data.kindData);
      formateMapData(res.data.charts);
      setIds(res.data.myids);
      fetchSpeedway(res.data.myids);
    }
  };

  const fetchSpeedway = async (ids: number[]) => {
    const res = await fetchSuperTestShock({ myids: ids.toString() });

    if (res.status === 12000) {
      setShockData(res.data);
    }
  };

  const formateMapData = (data: ChartsType) => {
    const obj = {};

    for (let key in data) {
      const mapkey = data[key]?.["templateId"];

      if (mapkey) {
        obj[mapkey] = data[key];
      }
    }

    setChartsMapData(obj);
  };

  useEffect(() => {
    setTimeout(() => {
      fetch();
    }, 1000);
  }, []);

  return (
    <Context.Provider
      value={{
        charts,
        chartMapData,
        kindData,
        shockData,
        setCompare,
        compareMyid,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default Provider;
